import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Dashboard(主控版)
const Dashboard = () => import('@/views/Dashboard')

// Proudction(生產作業)
const ProductionCalendar = () => import('@/views/production/Calendar')
const ProductionKanban = () => import('@/views/production/Kanban')
const ProductionRecipe = () => import('@/views/production/Recipe')
const ProductionStock = () => import('@/views/production/Stock')
const ProductionAcidity= () => import('@/views/production/Acidity')
const ProductionRefund = () => import('@/views/production/Refund')

// Report(報表)
const ReportProduction = () => import('@/views/report/Production')
const ReportDeploy = () => import('@/views/report/Deploy')
const ReportPotCondition = () => import('@/views/report/PotCondition')
const ReportPutMaterials = () => import('@/views/report/PutMaterials')
const ReportPackage = () => import('@/views/report/Package')
const ReportMadeTest = () => import('@/views/report/MadeTest')
const ReportBagOtype = () => import('@/views/report/BagOtype')
const ReportWeight = () => import('@/views/report/Weight')
const ReportOutPackage = () => import('@/views/report/OutPackage')
const ReportSemiFinished = () => import('@/views/report/SemiFinished')
const ReportParameter = () => import('@/views/report/Parameter')

// Acceptance(供應鏈)
const AcceptanceCheck = () => import('@/views/acceptance/Check')
const AcceptanceSCM = () => import('@/views/acceptance/SCM')
const AcceptanceSCMEvaluation = () => import('@/views/acceptance/SCMEvaluation')
const AcceptanceCustomer = () => import('@/views/acceptance/Customer')
const AcceptanceWarehouse = () => import('@/views/acceptance/Warehouse')
const AcceptanceQuality = () => import('@/views/acceptance/Quality')

// SCM(供應鏈管理系統)
const SCMPurchase = () => import('@/views/scm/Purchase')
const SCMWarehouse = () => import('@/views/scm/Warehouse')
const SCMQuality = () => import('@/views/scm/Quality')

// System(系統管理)
const SystemMessage = () => import('@/views/system/Message')
const SystemEditMessage = () => import('@/views/system/EditMessage')
const SystemMyMessage = () => import('@/views/system/MyMessage')
const SystemMyMessageList = () => import('@/views/system/MyMessageList')
const SystemPubMessage = () => import('@/views/system/PubMessage')
const SystemUsers = () => import('@/views/system/Users')
const SystemLimit = () => import('@/views/system/Limit')
const SystemOwner = () => import('@/views/system/Owner')
const SystemActivite = () => import('@/views/system/Activite')
const SystemReceiveMaterial = () => import('@/views/system/ReceiveMaterial')
const SystemCheckItem = () => import('@/views/system/CheckItem')



Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: '主控版',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: '主控版',
          component: Dashboard
        },  
        {
          path: '/system/mymessagelist',
          name: '訊息清單',
          component: SystemMyMessageList,         
        },  
        {
          path: '/system/mymessage',
          name: '我的訊息',
          component: SystemMyMessage,         
        },  
        {
          path: 'production',
          redirect: '/production/calendar',
          name: '生產作業',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'calendar',
              name: '生產排程行事歷',
              component: ProductionCalendar
            },
            {
              path: 'kanban',
              name: '生產看版',
              component: ProductionKanban
            },
            {
              path: 'recipe',
              name: '配方表管理',
              component: ProductionRecipe
            },
            {
              path: 'stock',
              name: '庫存清單',
              component: ProductionStock
            },
            {
              path: 'Acidity',
              name: '原醋酸度設定',
              component: ProductionAcidity
            },
            {
              path: 'Refund',
              name: '製令補退料',
              component: ProductionRefund
            }            
          ]
        },       
        {
          path: 'report',
          redirect: '/report/production',
          name: '表單管理',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'production',
              name: '生產日報表',
              component: ReportProduction
            },
            {
              path: 'potcondition',
              name: '調理投料管制表',
              component: ReportPotCondition
            },
            {
              path: 'deploy',
              name: '調理日報表',
              component: ReportDeploy
            },
            {
              path: 'putmaterials',
              name: '投料管制表',
              component: ReportPutMaterials
            },
            {
              path: 'package',
              name: '包裝日報表',
              component: ReportPackage
            },
            {
              path: 'madeTest',
              name: '製程檢驗報告單',
              component: ReportMadeTest
            },
            {
              path: 'bagOtype',
              name: '濾袋＆Ｏ型環報表單',
              component: ReportBagOtype
            },
            {
              path: 'semiFinished',
              name: '半成品檢驗單',
              component: ReportSemiFinished
            },
            {
              path: 'weight',
              name: '重量檢點表',
              component: ReportWeight
            },
            {
              path: 'putpackage',
              name: '外包裝檢點表',
              component: ReportOutPackage
            },
            {
              path: 'parameter',
              name: '生產產能參數',
              component: ReportParameter
            }
          ]
        },
        {
          path: 'acceptance',
          redirect: '/acceptance/scm',
          name: '供應商管理',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'check',
              name: '進料檢驗',
              component: AcceptanceCheck
            },
            {
              path: 'scm',
              name: '供應商管理',
              component: AcceptanceSCM,            
            },
            {
              path: 'customer',
              name: '供應商明細',
              component: AcceptanceCustomer              
            }, 
            {
              path: 'scmevaluation',
              name: '供應商評鑑',
              component: AcceptanceSCMEvaluation              
            }, 
            {
              path: 'warehouse',
              name: '倉管檢驗',
              component: AcceptanceWarehouse              
            }, 
            {
              path: 'quality',
              name: '品保檢驗',
              component: AcceptanceQuality              
            }  
                  
                              
          ]
        },
        {
          path: 'system',
          redirect: '/system/message',
          name: '系統管理',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'message',
              name: '訊息管理',
              component: SystemMessage,
              children: [
                {
                  path: 'editmessage',
                  name: '編輯訊息',
                  component: SystemEditMessage                 
                },
              ]
            },
            {
              path: 'editmessage',
              name: '編輯訊息',
              component: SystemEditMessage             
            },            
            {
              path: 'pubmessage',
              name: '公開訊息',
              component: SystemPubMessage
            },
            {
              path: 'users',
              name: '人員管理',
              component: SystemUsers
            },
            {
              path: 'limit',
              name: '權限管理',
              component: SystemLimit
            },
            {
              path: 'receivematerial',
              name: '收料管理',
              component: SystemReceiveMaterial
            },
            {
              path: 'checkitem',
              name: '檢驗管理',
              component: SystemCheckItem
            },
            
            {
              path: 'owner',
              name: '個人資料',
              component: SystemOwner
            },
            {
              path: 'activite',
              name: '行為分析',
              component: SystemActivite
              
            }
          ]
        },        
       
        {
          path: '/scm/purchase',
          name: '採購資料',
          component: SCMPurchase,         
        },  
        {
          path: '/scm/warehouse',
          name: '倉管檢驗',
          component: SCMWarehouse,         
        },
        {
          path: '/scm/quality',
          name: '品保檢驗',
          component: SCMQuality,         
        }, 
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

